import React, { useState } from "react";
import { Button } from "../Button/Button";
import { ApiRequest } from "../../api/Api";
import styled from "styled-components";

export const RegistrationForm = () => {
	const [login, setLogin] = useState<string>();
	const [password, setPassword] = useState<string>();
	const [qrCode, setQrCode] = useState("");

	const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const response = await ApiRequest("/auth/register", {
			login,
			password,
		});
		if (response?.data) {
			setQrCode(response.data);
		}
	};

	return (
		<form method="post" onSubmit={(e) => submitHandler(e)}>
			<input
				type="text"
				placeholder="Login"
				onChange={(e) => setLogin(e.target.value)}
				value={login}
			/>
			<input
				type="password"
				placeholder="Password"
				onChange={(e) => setPassword(e.target.value)}
				value={password}
			/>
			{qrCode ? (
				<StyledQrCode>
					<div className="header">QRCode</div>
					<div className="body">
						<img src={qrCode} alt="QR Code для 2FA" />
					</div>
				</StyledQrCode>
			) : null}
			{qrCode ? null : <Button type="submit">Создать</Button>}
		</form>
	);
};

const StyledQrCode = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
`;
